import React, { useState,useEffect } from 'react';
import { cuurentNextYear } from './Function';
import { Card,Row,Col,ListGroup,Placeholder,Button } from 'react-bootstrap';
const PhdAdmissions = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programGroups,setGroups]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        const getProgramGroup = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programsGroup/all");
                const result = await response.json();
                setGroups(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('Program Groups : Result',result); }
              
            } catch (error) 
            {
                console.error('Program Groups : Error', error.message);
            }
        };
        getProgramGroup();    
    },[])
    return (
        <React.Fragment>
        {appLanguage === "hi" ? (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3' data-aos="flip-up" data-aos-duration="1000">पीएच.डी. प्रवेश प्रक्रिया</Card.Header>
            <Card.Body>
                <p className="h5 fw-bold" data-aos="flip-up" data-aos-duration="1000">पीएचडी कार्यक्रम में प्रवेश आम तौर पर साल में दो बार मई/जून और दिसंबर/जनवरी के दौरान होता है। यह प्रक्रिया दोनों श्रेणियों (पूर्णकालिक और अंशकालिक) के आवेदकों के लिए समान है।</p>
                <ol className="mt-3">
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">प्रवेश लिखित परीक्षा अर्थात आरएटी के आधार पर दिया जाएगा, जिसके बाद साक्षात्कार होगा।</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">आरएटी परीक्षा केवल 50% योग्यता अंकों के साथ उत्तीर्ण होगी। आरएटी परीक्षा उत्तीर्ण करने के लिए SC/ST/OBC/दिव्यांग (PD) श्रेणी के लिए 5% अंकों की छूट (50% से 45% तक) दी जाएगी।</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">आरएटी परीक्षा के पाठ्यक्रम में 50% शोध पद्धति और 50% विषय विशेष शामिल होगा। (कृपया www.igdtuw.ac.in देखें)</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">आवेदकों द्वारा जमा किया गया आवेदन शुल्क वापस नहीं किया जाएगा</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">कुछ आवेदकों के लिए आर.ए.टी. परीक्षा माफ कर दी जाएगी (विवरण के लिए प्रवेश विवरणिका देखें)</li>
                    <li className="text-justify">
                        आर.ए.टी. निम्नलिखित विषयों में आयोजित की जाएगी:
                        <ul>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">a. इलेक्ट्रॉनिक्स और संचार इंजीनियरिंग (ईसीई)</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">b. कंप्यूटर विज्ञान / सूचना प्रौद्योगिकी / कंप्यूटर अनुप्रयोग</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">c. मैकेनिकल और ऑटोमेशन इंजीनियरिंग</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">d. रसायन विज्ञान</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">e. गणित</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">f. भौतिकी</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">g. इलेक्ट्रिकल इंजीनियरिंग (इलेक्ट्रॉनिक्स और संचार इंजीनियरिंग विभाग के तहत)</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">h. वास्तुकला और नियोजन।</li>
                        </ul>
                    </li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">आरएटी परीक्षा का पाठ्यक्रम और अन्य संबंधित विवरण विश्वविद्यालय की वेबसाइट पर उपलब्ध हैं।</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">पीएचडी पाठ्यक्रम में प्रवेश लेने वाले सभी आवेदक आईजीडीटीयूडब्ल्यू के पीएचडी अध्यादेशों और विनियमों से बंधे होंगे।</li>
                    <li className="text-justify">
                        साक्षात्कार के लिए चुने गए आवेदकों को साक्षात्कार के दौरान अपने शोध रुचि/क्षेत्र पर चर्चा करनी होगी। साक्षात्कार में निम्नलिखित पहलुओं पर भी विचार किया जाएगा। क्या:
                        <ul>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">a. व्यक्ति के पास प्रस्तावित शोध के लिए योग्यता होनी चाहिए।</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">b. शोध कार्य विश्वविद्यालय में उपयुक्त रूप से किया जा सकता है।</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">c. शोध का प्रस्तावित क्षेत्र नए/अतिरिक्त ज्ञान में योगदान दे सकता है।</li>
                        </ul>
                    </li>
                </ol>
                <p className="text-justify" data-aos="flip-up" data-aos-duration="1000"><u>* यह प्रक्रिया केवल सांकेतिक है, अभ्यर्थी को संबंधित शैक्षणिक वर्ष की प्रवेश विवरणिका में दिए गए सटीक दिशा-निर्देशों/प्रक्रिया का संदर्भ लेना चाहिए।</u></p>
            </Card.Body>
        </Card>
        ) : (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3' data-aos="flip-up" data-aos-duration="1000">Ph.D. Admission Process</Card.Header>
            <Card.Body>
                <p className="h5 fw-bold" data-aos="flip-up" data-aos-duration="1000">Admission to the Ph.D. programme usually happens twice in an year during May/June and Dec/Jan. The process is common to both the categories (Full time and Part Time) of applicants.</p>
                <ol className="mt-3">
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">Admission shall be made on the basis of a written Test viz. RAT followed by an interview.</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">The RAT Examination shall be qualifying only with qualifying marks as 50%. A relaxation of 5% marks (from 50% to 45%) shall be allowed for SC/ST/OBC/Differently abled (PD) category to qualify the RAT Exam.</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">The syllabus of the RAT examination shall consist of 50% of Research Methodology and 50% subject specific. (Please refer www.igdtuw.ac.in)</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">The application fee deposited by the applicants is Non-Refundable</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">The RAT examination shall be waived off for some applicants (refer the admission brochure for details)</li>
                    <li className="text-justify">
                        The RAT shall be conducted in the following disciplines:
                        <ul>                        
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">a. Electronics and Communication Engineering (ECE)</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">b. Computer Science / Information Technology/ Computer Applications</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">c. Mechanical & Automation Engineering</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">d. Chemistry</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">e. Maths</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">f. Physics</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">g. Electrical Engineering (under the Department of Electronics and Communication Engineering)</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">h. Architecture & Planning.</li>
                        </ul>
                    </li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">The Syllabi and other related details of the RAT Examination are available on the University website.</li>
                    <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">All applicants taking admission in the Ph.D. Course shall be bound by the Ph.D. Ordinances and Regulations of the IGDTUW</li>
                    <li className="text-justify">
                        The applicants shortlisted for interview are required to discuss their research interest/ area during the interview. The interview shall also consider the following aspects viz. whether:
                        <ul>                        
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">a. The person should possess the competency for the proposed research.</li>                                                    
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">b. The research work can be suitably undertaken at the University.</li>
                            <li className="text-justify" data-aos="flip-up" data-aos-duration="1000">c. The proposed area of research can contribute to new/ additional knowledge.</li>
                        </ul>
                    </li>
                </ol>
                <p className="text-justify" data-aos="flip-up" data-aos-duration="1000"><u>* the process is only indicative, candidate should refer to the exact guidelines/procedure in the admission brochure of the concerned academic year.</u></p>
            </Card.Body>
        </Card>
        )}        
        {isLoading ? (
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3'><Placeholder xs={6} /></Card.Header>
            <Card.Body>
            <Row className='g-3'>
            {[...Array(3)].map((_, index) => (
                <Col md="auto" key={index}>
                    <Card className='bg-success-subtle'>
                        <Card.Header className='text-bg-primary text-center fs-5'><Placeholder xs={6} /></Card.Header>
                        <Card.Body>
                            <Row className='g-3'>
                                {[...Array(10)].map((_, index) => (
                                <Col md="auto" key={index}>
                                    <Card className=' text-center h-100'  style={{width:"13rem"}}>
                                        <Card.Header className='flex-grow-1 d-flex align-items-center justify-content-center'><Placeholder xs={8} /></Card.Header>
                                        <ListGroup variant="flush">
                                            <ListGroup.Item className='text-nowrap'><Placeholder xs={8} /></ListGroup.Item>
                                            <ListGroup.Item className='text-nowrap'><Placeholder xs={8} /></ListGroup.Item>
                                        </ListGroup>                
                                    </Card>
                                </Col>
                                ))}                          
                                <Col md="auto" className='d-flex flex-column justify-content-between'>
                                    <Button className='btn btn-info'><Placeholder xs={12} /></Button>
                                    <Button className='mt-3 btn btn-info'><Placeholder xs={12} /></Button> 
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
            </Row>
            </Card.Body>
        </Card>
        ) : (
            <React.Fragment>
            {programGroups.filter(pg => pg.pg_id === 3).map((pg,index)=>(
                <Card className='mb-4' key={index}>
                    <Card.Header className='text-center fs-3'>{appLanguage === "hi" ? pg.pg_name_hi || pg.pg_name : pg.pg_name}</Card.Header>
                    <Card.Body>
                        <ProgramType pgId={pg.pg_id} />
                    </Card.Body>
                </Card>
            ))}
            </React.Fragment>
        )}
        </React.Fragment>        
    );
}
export default PhdAdmissions;
const ProgramType = ({pgId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programType,setType]=useState([]);
    useEffect(()=>
    {
        const getProgramType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programsType/byProgramGroup/"+pgId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.pt_id + "/ptBrochure")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.pt_id + "/ptBrochureHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].ptBrochure = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].ptBrochureHi = (el.upph.length > 0) ? global.config.uploadPath + el.upph[0].up_fname + el.upph[0].up_ext : '';                            
                        });
                        setType(result);
                    }).catch(error => {
                        console.error('Program Type File :', error);
                    });
                }
                else
                {
                    setType([]);
                }
                if( global.config.IsPrint === true ) { console.info('Program Type : Result',result); }
              
            } catch (error) 
            {
                console.error('Program Type : Error', error.message);
            }
        };
        getProgramType();    
    },[pgId])
    return (
        <Row className='g-3'>
        {programType.map((pt,index)=>(
            <Col md="auto" key={index}>
                <Card className='text-bg-light border-primary'>
                    <Card.Header className='text-bg-primary border-primary text-center fs-5'>
                        {appLanguage === 'hi' ? (pt.pt_display_en === "1" ? pt.pt_name_hi || '' : pt.pt_name_hi || pt.pt_name) : pt.pt_name}
                    </Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                            <Programs ptId={pt.pt_id} />                          
                            <Col md="auto" className='d-flex flex-column justify-content-between'>
                            {appLanguage === 'hi' ? 
                                (
                                    pt.pt_display_en === "1" && pt.brochureHi 
                                    ? <a href={pt.brochureHi} className='btn btn-info' target='_blank' rel="noreferrer">प्रवेश ब्रोशर<br />{cuurentNextYear()}</a> 
                                    : pt.brochureHi 
                                        ? <a href={pt.brochureHi} className='btn btn-info' target='_blank' rel="noreferrer">प्रवेश ब्रोशर<br />{cuurentNextYear()}</a> 
                                        : pt.brochure
                                        ? <a href={pt.brochure} className='btn btn-info' target='_blank' rel="noreferrer">प्रवेश ब्रोशर<br />{cuurentNextYear()}</a> 
                                        : ''
                                ) : (
                                    pt.brochure 
                                    ? <a href={pt.brochure} className='btn btn-info' target='_blank' rel="noreferrer">Admission Brochure<br />{cuurentNextYear()}</a> 
                                    : ''
                                )
                            }
                            { pt.pt_admission_link && <a href={pt.pt_admission_link} className='mt-3 btn btn-info' target='_blank' rel="noreferrer">
                                {appLanguage === 'hi' ? 'प्रवेश पोर्टल के लिए लिंक' : 'Link to Admission Portal'}<br />{cuurentNextYear()}
                            </a> } 
                            </Col>
                        </Row>
                        {pt.pt_admission_procedure !==null || pt.pt_admission_procedure !=='null' ? (
                            <div className='mt-3'>
                                <h5 className='border-bottom border-dark'>{appLanguage === 'hi' ? 'प्रवेश प्रक्रिया' : 'Admission Procedure'}</h5>
                                <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (pt.pt_display_en === "1" ? pt.pt_admission_procedure_hi || '' : pt.pt_admission_procedure_hi || pt.pt_admission_procedure) : pt.pt_admission_procedure}} />
                            </div>
                        ) : null }
                    </Card.Body>
                </Card>
            </Col>
        ))}
        </Row>       
    );
}
const Programs = ({ptId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programs,setPrograms]=useState([]);
    useEffect(()=>
    {
        const getPrograms = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programs/programType/"+ptId);
                const result = await response.json();
                setPrograms(result);
                if( global.config.IsPrint === true ) { console.info('Programs : Result',result); }
              
            } catch (error) 
            {
                console.error('Programs : Error', error.message);
            }
        };
        getPrograms();    
    },[ptId])
    return (
        <React.Fragment>
        {programs.map((p,index)=>(
        <Col md="auto" key={index}>
            <Card className='text-center h-100'  style={{width:"13rem"}}>
                <Card.Header className='flex-grow-1 d-flex align-items-center justify-content-center fw-bold text-bg-info bg-info-subtle'>
                    {appLanguage === 'hi' ? (p.p_display_en === "1" ? p.p_name_hi || '' : p.p_name_hi || p.p_name) : p.p_name}
                </Card.Header>
                { p.p_intake > 0 && <ListGroup variant="flush">
                                        <ListGroup.Item className='text-nowrap'>{appLanguage === 'hi' ? 'समयांतराल:' : 'Duration:'} {p.p_duration} {appLanguage === 'hi' ? 'वर्ष' : 'Year'}</ListGroup.Item>
                                        <ListGroup.Item className='text-nowrap'>{appLanguage === 'hi' ? 'प्रवेश:' : 'Intake:'} {p.p_intake}</ListGroup.Item>
                                    </ListGroup>
                }
            </Card>
        </Col>
        ))}
        </React.Fragment>
    );
}